import { DocumentData } from "@angular/fire/firestore";
import { ProductAdvancedSettings } from "../models";
import { CustomPurchaseWindow } from "../models/custom-purchase-window";
import { CustomRedeemWindow } from "../models/custom-redeem-window";
import { RedeemType } from "../enums/redeem-type.enum";

export class ProductAdvancedSettingsBuilder {
  public visibleDaysBeforeEvent: number;
  public purchaseWindow: CustomPurchaseWindow;
  public redeemWindow: CustomRedeemWindow;
  constructor() {
    this.purchaseWindow = new CustomPurchaseWindow(null, null, null);
    this.redeemWindow = new CustomRedeemWindow(null, null, null, null);
  }

  load(data: DocumentData) {
    this.visibleDaysBeforeEvent = data.visibleDaysBeforeEvent;
    this.purchaseWindow = new CustomPurchaseWindow(
      data.purchaseWindow.start,
      data.purchaseWindow.end,
      data.purchaseWindow.timeOnLastDay
    );
    this.redeemWindow = new CustomRedeemWindow(
      data.redeemWindow.type,
      data.redeemWindow.dayOfEventBeginTime,
      data.redeemWindow.dayOfEventEndTime,
      data.redeemWindow.daysAfterEvent
    );
  }
  edit(advanced: ProductAdvancedSettings) {
    this.visibleDaysBeforeEvent = advanced.visibleDaysBeforeEvent;
    this.purchaseWindow = advanced.purchaseWindow;
    this.redeemWindow = advanced.redeemWindow;
  }

  setVisibility(days: number) {
    this.visibleDaysBeforeEvent = days;
    return this;
  }

  setPurchaseWindow(window: CustomPurchaseWindow) {
    this.purchaseWindow = window;
    return this;
  }

  setRedeemWindow(
    redeemType: RedeemType,
    redeemFrom: string,
    redeemTo: string,
    redeemDaysAfter: number
  ) {
    switch (redeemType) {
      case RedeemType.DayOfEvent:
        this.redeemWindow = new CustomRedeemWindow(
          redeemType,
          redeemFrom,
          redeemTo,
          null
        );
        return this;
      case RedeemType.AnytimeDuringAndAfter:
        this.redeemWindow = new CustomRedeemWindow(
          redeemType,
          null,
          null,
          null
        );
        return this;
      case RedeemType.DaysAfterEvent:
        this.redeemWindow = new CustomRedeemWindow(
          redeemType,
          null,
          null,
          redeemDaysAfter
        );
        return this;
    }
  }
}
